import styled from "styled-components";

export const Container = styled.div`
  padding: 30px 0px;
  text-align: center;
`;
export const Header = styled.h3`
  margin: 0;
  padding: 0;
  /* text-transform: uppercase; */
  font-size: 30px;
  font-weight: 600;
`;
export const SubHeader = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
`;
